'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('./../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');
require('./MobileNav/MobileNav.js');
var MobileNavLG = require('./MobileNav/MobileNavLG.js');
require('./MobileNav/MobileNavDrawer/MobileNavDrawer.js');
require('./MobileNav/MobileNavItem/MobileNavItem.js');
var Nav = require('./Nav/Nav.js');
require('./Nav/NavDropdown/NavDropdown.js');
var NavDropdownLG = require('./Nav/NavDropdown/NavDropdownLG.js');
var UtilityNavQwik = require('./UtilityNav/UtilityNavQwik.js');
var SearchBar = require('./SearchBar/SearchBar.js');
var nav = require('../../utilities/nav.js');
var index$1 = require('./LanlLogo/index.js');
var hamburger_inline = require('../../assets/svg/hamburger.inline.svg.js');
var close_inline = require('../../assets/svg/close.inline.svg.js');
var useMobileBool = require('../../utilities/hooks/useMobileBool.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var HeaderQwik = function HeaderQwik(_ref) {
  var animLogo = _ref.animLogo,
    landingName = _ref.landingName,
    navData = _ref.navData,
    config = _ref.config;
  var _useState = React.useState(navData),
    _useState2 = slicedToArray.default(_useState, 2),
    headerData = _useState2[0];
    _useState2[1];
  var _useState3 = React.useState(landingName),
    _useState4 = slicedToArray.default(_useState3, 2),
    activeLandingName = _useState4[0],
    setActiveLandingName = _useState4[1];
  var _headerData$lc_menu = headerData.lc_menu,
    lc_menu = _headerData$lc_menu === void 0 ? {} : _headerData$lc_menu,
    _headerData$lg_landin = headerData.lg_landing,
    lg_landing = _headerData$lg_landin === void 0 ? {} : _headerData$lg_landin,
    lg_utility_menu = headerData.lg_utility_menu,
    menu_articles_mission = headerData.menu_articles_mission,
    menu_articles_science = headerData.menu_articles_science,
    menu_articles_community = headerData.menu_articles_community,
    menu_articles_environment = headerData.menu_articles_environment;
  var menuData = nav.cleanMenuData(lg_landing, lc_menu, config.main);
  var utilMenuData = nav.cleanUtilMenuData(lg_utility_menu, config.utility);
  var menu_articles_science_short = menu_articles_science.slice(0, 3);
  var menu_articles_collaboration = menu_articles_science.slice(3);
  var _useState5 = React.useState(null),
    _useState6 = slicedToArray.default(_useState5, 2),
    activeNavItem = _useState6[0],
    setActiveNavItem = _useState6[1];
  var _useState7 = React.useState(false),
    _useState8 = slicedToArray.default(_useState7, 2),
    searchIsActive = _useState8[0],
    setSearchIsActive = _useState8[1];
  var menuArticles = {
    menu_articles_science: menu_articles_science_short,
    menu_articles_mission: menu_articles_mission,
    menu_articles_community: menu_articles_community,
    menu_articles_collaboration: menu_articles_collaboration,
    menu_articles_environment: menu_articles_environment
  };
  var navwrapperClasses = index.default('main-nav-wrapper', searchIsActive ? 'search-active' : '');
  var isMobile = useMobileBool.useMobileBool();
  React.useEffect(function () {
    var body = document.querySelector('body');
    if (activeNavItem && body) {
      body.classList.add('no-scroll');
      setActiveLandingName('');
    } else {
      body.classList.remove('no-scroll');
      setActiveLandingName(landingName);
    }
  }, [activeNavItem]);
  return /*#__PURE__*/React__default.default.createElement(React__default.default.Fragment, null, isMobile ? /*#__PURE__*/React__default.default.createElement("div", {
    "data-testid": "lanl-header-mobile",
    className: "lanl-header lanl-header--mobile"
  }, /*#__PURE__*/React__default.default.createElement("div", {
    className: navwrapperClasses
  }, /*#__PURE__*/React__default.default.createElement(index$1.LanlLogo, {
    animLogo: animLogo
  }), activeNavItem ? /*#__PURE__*/React__default.default.createElement(close_inline.default, {
    className: "lanl-mobile-close-icon",
    onClick: function onClick() {
      return setActiveNavItem(null);
    }
  }) : /*#__PURE__*/React__default.default.createElement(hamburger_inline.default, {
    onClick: function onClick() {
      return setActiveNavItem('mobile');
    }
  })), /*#__PURE__*/React__default.default.createElement(MobileNavLG.MobileNavLG, {
    activeNavItem: activeNavItem,
    headerData: {
      navData: menuData,
      utilityNavData: utilMenuData
    }
  })) : /*#__PURE__*/React__default.default.createElement("div", {
    "data-testid": "lanl-header",
    className: "lanl-header lanl-header--desktop"
  }, /*#__PURE__*/React__default.default.createElement(UtilityNavQwik.UtilityNavQwik, {
    utilityNavData: utilMenuData
  }), /*#__PURE__*/React__default.default.createElement("div", {
    className: navwrapperClasses
  }, /*#__PURE__*/React__default.default.createElement(index$1.LanlLogo, {
    animLogo: animLogo
  }), /*#__PURE__*/React__default.default.createElement(Nav.Nav, {
    navItems: menuData,
    activeNavItem: activeNavItem,
    landingName: activeLandingName,
    setActiveItemCb: setActiveNavItem,
    searchIsActive: searchIsActive
  }), /*#__PURE__*/React__default.default.createElement(SearchBar.SearchBar, {
    active: searchIsActive,
    setSearchIsActive: setSearchIsActive
  })), activeNavItem && activeNavItem !== 'mobile' && /*#__PURE__*/React__default.default.createElement(NavDropdownLG.NavDropdownLG, {
    activeNavItem: activeNavItem,
    setActiveNavItem: setActiveNavItem,
    navItems: menuData,
    menuArticles: menuArticles
  })));
};
HeaderQwik.defaultProps = {
  landingName: ''
};
HeaderQwik.propTypes = {
  navData: PropTypes__default.default.object.isRequired,
  animLogo: PropTypes__default.default.node,
  config: PropTypes__default.default.shape({
    main: PropTypes__default.default.array,
    utility: PropTypes__default.default.array
  }),
  landingName: PropTypes__default.default.string
};

exports.HeaderQwik = HeaderQwik;
exports.default = HeaderQwik;
//# sourceMappingURL=HeaderQwik.js.map
